module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-700italic.woff2?5cfb020a3193dddf2dc041eb7e183ad3";